export const VIEW_TYPES = {
  PAGE: 'page',
  MODAL: 'modal',
};

export const MODAL_MODES = {
  EDITING: 'editing',
  MINIMIZED: 'minimized',
  CLOSED: 'closed',
};

export const DRAFT_STATUSES = {
  DRAFT: 'draft',
  SCHEDULED: 'scheduled',
  DELIVERED: 'delivered',
  FAILED: 'failed',
};
